<div class="card mb-4">
  <div class="card-header">
    <app-report-filter [fg]="fg" (submit)="onSubmit($event)"></app-report-filter>
  </div>
  <div class="card-body">
    <app-acc-loader *ngIf="waitHandler.processing"></app-acc-loader>
    <app-acc-piechart *ngIf="!waitHandler.processing&&(rendered$|async)"></app-acc-piechart>
  </div>
  <div class="card-footer"></div>
</div>